import React, { useState, useEffect } from "react";
import "./Login.css";
import Form from "react-bootstrap/Form";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [fname, setFname] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [newSession, setNewSession] = useState(false);
  const [showSessionCheckbox, setShowSessionCheckbox] = useState(false);

  const dispatch = useDispatch();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError("");

    const api = `${process.env.REACT_APP_API_LINK}/api/v1/auth/login`;
    const getProlife = `${process.env.REACT_APP_API_LINK}/api/v1/auth/getProfile`;

    try {
      const res = await axios.post(
        api,
        {
          username: fname.trim(),
          password: password,
          newSession: newSession,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      console.log("res data from login api?", res.data);
      // return;
      // getProfile API
      if (res.data) {
        const token = res.data.accessToken;
        try {
          const response = await axios.get(getProlife, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // use updated token here
            },
          });
          // console.log(response.data);
          localStorage.setItem(
            "userProfile",
            JSON.stringify(response.data.user),
          );
        } catch (error) {
          console.log(error.response.data.message);
        }
      }
      if (res.data) {
        const { accessToken, user, username, admin } = res.data; // Extract token and other data
        dispatch(
          loginSuccess({
            user: user,
            token: accessToken,
            username: user.username,
            admin: user.admin,
          }),
        );

        // Store token in localStorage
        localStorage.setItem("authToken", accessToken);
        localStorage.setItem("username", user.username);
        localStorage.setItem("admin", user.admin);
        // navigate("/customer-summary");
        window.location.href = "/customer-summary";
      }
    } catch (error) {
      console.log("API request failed", error);
      if (error?.response?.data?.message === "User is already logged in") {
        setShowSessionCheckbox(true);
      }
      setError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // const handleKeyPress = (event) => {
  //   if (event.key === "Enter") {
  //     handleLogin(event);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("keypress", handleKeyPress);

  //   return () => {
  //     window.removeEventListener("keypress", handleKeyPress);
  //   };
  // }, []);

  return (
    <form onSubmit={handleLogin}>
      <div className="login_main">
        <div className="login_auth_main">
          <div className={error.length > 0 ? "login_form1" : "login_form"}>
            <div
              className={error.length > 0 ? "form_heading1" : "form_heading"}
            >
              GoPlan{" "}
              {window.location.origin === "https://goplan.lerros.de"
                ? ""
                : "Test"}
            </div>
            <div className="login_form_main">
              <div className="login_user_both">
                <div className="form_title">
                  <Form.Label htmlFor="username">Username</Form.Label>
                </div>
                <div className="form_input">
                  <Form.Control
                    type="text"
                    id="username"
                    name="username"
                    placeholder="Enter your username"
                    autoComplete="off"
                    value={fname}
                    onChange={(e) => {
                      setFname(e.target.value.trim());
                    }}
                  />
                </div>
              </div>

              <div className="login_user_both">
                <div className="form_title">
                  <Form.Label htmlFor="password">Password</Form.Label>
                </div>
                <div className="form_input" style={{ position: "relative" }}>
                  <Form.Control
                    type={passwordVisible ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    autoComplete="off"
                    style={{ paddingRight: "30px" }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div id="eye_createuser" onClick={togglePasswordVisibility}>
                    {passwordVisible ? <FaRegEyeSlash /> : <FaRegEye />}
                  </div>
                </div>
              </div>

              {showSessionCheckbox && (
                <div className="pl-3">
                  <Form.Check
                    type="checkbox"
                    id="new-session"
                    label="End previous session"
                    checked={newSession}
                    onChange={(e) => setNewSession(e.target.checked)}
                  />
                </div>
              )}
            </div>

            {/* Show error message if there's an error */}
            {error && <div id="error_msg">{error}</div>}

            <div className="login_button">
              <button
                type="submit"
                className="btn btn-success"
                // onClick={handleLogin}
                disabled={loading}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") handleLogin(e);
                // }}
              >
                {loading ? (
                  <div id="loading_both">
                    <i id="spinner" className="fa fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  "Login"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Login;
